
<template>
  <div :style="{ height: curBoxHeight, maxHeight }">
    <!-- 表格数据 style="height:100%" :style="{ height: boxHeight }" :height="tableHeight" height="250"-->
    <el-table
      v-loading="loading"
      ref="tableData"
      header-row-class-name="table-header"
      border
      max-height="100%"
      height="100%"
      highlight-current-row
      :data="tableData"
      :size="size"
      :default-sort="defaultSort"
      :header-cell-style="setHeaderStyle"
      :cell-style="cellStyle"
      :span-method="spanMethod"
      style="height: 100%;position: relative;border-right:.01rem solid #dedede;border-bottom:.01rem solid #dedede"
      @sort-change="sortChange"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @row-click="rowClick"
    >
      <!-- 多选框 -->
      <el-table-column
        v-if="selection"
        type="selection"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column v-if="indexable" label="序号" width="80" align="center">
         <template slot-scope="scope">
             <div class="indexBox">
              <span v-if="hasTotalRow && tableData && scope.$index == tableData.length - 1" >  {{ totalRowText }} </span>
              <span v-else> {{ scope.$index + 1 }}</span>
              <template v-if="iconSlotName">
                <slot :name="iconSlotName" :data="scope" />
              </template>
             </div>
          </template>
      </el-table-column>
      <!-- 文本数据渲染 -->
      <template v-for="item in tableHead">
        <template v-if="item.show == false?false:true">
        <el-table-column
          v-if="item.columnType === 'slot'"
          :prop="item.value"
          :label="item.label"
          :key="item.key?item.key:item.value"
          :width="item.width"
          header-align="center"
          :align="item.align || 'center'"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.tooltip==false?false:true"
          :sortable="item.sortable||false"
        >
          <template slot-scope="scope">
            <slot :name="item.slotName" :data="scope" />
          </template>
        </el-table-column>
        <!--适应在页面定义插槽通过map获取数据-->
        <el-table-column
          v-else-if="item.columnChildrenType === 'slot' && !item.children"
          :prop="item.value"
          :label="item.label"
          :key="item.key?item.key:item.value"
          :width="item.width"
          header-align="center"
          :align="item.align || 'center'"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.tooltip==false?false:true"
          :sortable="item.sortable||false"
        >
          <template slot-scope="scope">
             <slot :params="item.value" :rowData="scope.row" />
          </template>
        </el-table-column>
        <!--普通多级表头-->
        <EXTableColumn
        v-else-if="item.columnType==='multistable' && item.children && item.children.length"
        :key="item.key?item.key:item.value"
        :coloumn-header="item"
        ></EXTableColumn>
        <!--特殊多级表头，解决不同路由同一个页面的调用，表头只到三级-->
        <el-table-column
         v-else-if="item.columnType==='specialMultistable' && item.children && item.children.length"
          :key="item.key?item.key:item.value"
          :align="item.align || 'center'"
          :width="item.width"
          :label="item.label"
          :prop="item.value"
          header-align="center"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.tooltip==false?false:true"
          :sortable="item.sortable||false"
        >
          <template v-for="item in item.children">
            <el-table-column
              v-if="item.children && item.children.length"
              :align="item.align || 'center'"
              :width="item.width"
              :key="item.key?item.key:item.value"
              :label="item.label"
              :prop="item.value"
              header-align="center"
              :fixed="item.fixed"
              :show-overflow-tooltip="item.tooltip==false?false:true"
              :sortable="item.sortable||false"
            >
            <template v-for="itemChild in item.children">
              <el-table-column
                :align="itemChild.align || 'center'"
                :width="itemChild.width"
                :key="itemChild.key?itemChild.key:itemChild.value"
                :label="itemChild.label"
                :prop="itemChild.value"
                header-align="center"
                :fixed="itemChild.fixed"
                :show-overflow-tooltip="itemChild.tooltip==false?false:true"
                :sortable="itemChild.sortable||false"
             >
               <template v-if="item.columnChildrenType === 'slot'" slot-scope="scope">
                  <slot :params="itemChild.value" :rowData="scope.row" />
               </template>
              </el-table-column>
            </template>
            </el-table-column>
            <!--第二层嵌套-->
            <el-table-column
              v-else
              :align="item.align || 'center'"
              :width="item.width"
              :key="item.key?item.key:item.value"
              :label="item.label"
              :prop="item.value"
              header-align="center"
              :fixed="item.fixed"
              :show-overflow-tooltip="item.tooltip==false?false:true"
              :sortable="item.sortable||false"
            >
            <template v-if="item.columnChildrenType === 'slot'" slot-scope="scope">
                <slot :params="item.value" :rowData="scope.row" />
            </template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :prop="item.value"
          :label="item.label"
          :key="item.key?item.key:item.value"
          :width="item.width"
          header-align="center"
          :align="item.align || 'center'"
          :fixed="item.fixed"
          :show-overflow-tooltip="item.tooltip==false?false:true"
          :sortable="item.sortable||false"
        ></el-table-column>
      </template>
      </template>
    </el-table>
    <!--无数据时显示的内容-->
    <template slot="empty">
      <nodata></nodata>
    </template>
  </div>
</template>
<script>
/**
 * @name:
 * @test: test font
 * @msg:
 * @param {
 *  接收参数:
 *      tableHeadConfig           列的名称、接收值     |     Array
 *        label         列的名称                      |     String
 *        value         列的对应值                    |     String
 *        columnType    定义当前列为插槽    |   slot   |     String
 *        slotName      定义当前列插槽的名字           |     String
 *        width         定义当前列的宽度               |     String
 *        fiexed        定义当前列是否固定 | String
 *        tooltip       鼠标浮上去显示文字 | String
 *  示例：配置
 *      tableHeadConfig:[
 *              {
 *                label       : "缩略图",
 *                value       : "skuName",
 *                columnType  : "slot",
 *                slotName    : "thumbnail",
 *                width       : 240,
 *                fiexed      : "right",
 *              }
 *            ]
 *
 *      tableLoadData     异步获取的table文本数据信息
 *      align             表格单元格内容排列顺序      left|center|right
 *      selection         表格是否可多选
 *      indexable         表格是否显示序号列
 *      height            表格默认撑开高度
 *  事件：
 *      获取当前选中行
 *      调用页面用  @selectLine="xxx" 进行监听处理
 *
 * 接收参数:
 *      tableData   表格内容对应的数据   |     Array
 *      deviceName
 *      deviceType
 *      deviceLevel   跟接口返回的字段一致
 * 示例：
 *      tableData: [
 *          {
 *             deviceName: 'HSD-M水位计',
 *             deviceType: '水位计',
 *             deviceLevel: '一级',
 *          }
 *      ]
 *
 * }
 * @return:
 */
import nodata from "@/components/EXNodata/index";

export default {
  name: 'EXTable',
  components: {
    nodata,
  },
  props: {
    height: String,
    // 请求接口
    api: {
      // required: true,
    },
    // 参数  默认返回分页和条数
    params: {
      type: [Object, String, Number],
      default: function () {
        return { page: 1, limit: 10 };
      },
    },
    // 尺寸
    size: {
      default: "small",
    },
    // 分页
    paging: {
      default: true,
    },
    // 表格数据,
    tableData: {
      type: Array,
    },
    // 整体右侧盒子高度
    boxHeight: {
      type: String
    },
    // 表格对应的列的内容
    tableHeadConfig: {
      type: Array,
    },
    // 表格是否可多选
    selection: {
      type: Boolean,
      default: false,
    },
     // 表格是否显示序号列
     indexable: {
      type: Boolean,
      default: true,
    },
    // 表格内容是否居中
    align: {
      type: String,
      default: "center",
    },
    height: {
      type: [Number, String],
      default: 250,
    },
    maxHeight: String,
    loading: {
      // loading动画
      type: Boolean,
      default: false,
    },
    defaultSort:{
      type: Object
    },
    // headerStyle:{
    //   type:Object
    // },
    cellStyle:{
      type:Function
    },
    hasTableBtns: {
      type: Boolean,
      default: false,
    },
    hasDesc: {
      type: Boolean,
      default: false,
    },
    //数据跨行
    spanMethod:{
      type:Function
    },
    //是否隐藏表头第二行
    headerRowable:{
      type: Boolean,
      default: false,
    },
    //是否具有合计行：隐藏序号
    hasTotalRow: {
      type: Boolean,
      default: false
    },
    //合计行名称
    totalRowText: {
      type: String,
      default: "合计",
    },
    //序号图标插槽名称
    iconSlotName: String
  },
  data() {
    return {
      tableCount: 0, // 总条数
    };
  },
  activated() {
    // this.init(this.params);
    // 解决表格行错位问题和列宽伸缩变形问题

    if (this.$refs.tableData) {
      this.$refs.tableData.doLayout();
      this.$forceUpdate();
    }
  },
  mounted(){
    this.handleIntersection();
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    // console.log('addEventListener visibilitychange');
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    // console.log('removeEventListener visibilitychange');
  },
  computed: {
    tableHead() {
      return this.tableHeadConfig;
    },
    // 实时更新server
    server: function () {
      return this.api.split(".")[0];
    },
    // 实时更新url
    url: function () {
    return this.api.split(".")[1];
    },
    tableHeight: function () {
      // return this.paging ? "calc(100% - 32px)" : "100%";
      return "300px";
    },
    //计算表格高度
    curBoxHeight (){
      if(!this.boxHeight){
        if(this.hasTableBtns && this.hasDesc){
          return "calc(100% - 1.01rem)"
        }else if(this.hasTableBtns && !this.hasDesc){
          return "calc(100% - 0.47rem)"
        }else if(!this.hasTableBtns && this.hasDesc){
          return "calc(100% - 0.65rem)"
        }else{
          return "calc(100% - 0.11rem)"
        }
      }
      return this.boxHeight
    }
  },
  methods: {
    handleIntersection() {
      try {
        const _this = this;
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          console.log('是否可见:', entry.isIntersecting);
          // 处理逻辑（entry.isIntersecting 为 true 表示可见）
          if (entry.isIntersecting) {
            _this.$nextTick(() => {
              // 确保 DOM 更新后调用
              _this.$refs.tableData.doLayout();
            });
          }
        });
        // 观察整个文档根元素
        // observer.observe(document.documentElement);
        observer.observe(this.$refs.tableData.$el);
      } catch (e) {
        console.error('EXTable表格重构会出现异常:');
      }
    },
    handleVisibilityChange() {
      try {
        if (document.visibilityState === 'visible') {
          console.log('EXTable页面显示');
          this.$nextTick(() => {
            // 确保 DOM 更新后调用
            this.$refs.tableData.doLayout();
          });
        } else {
          console.log('EXTable页面隐藏');
        }
      } catch (e) {
        console.error('EXTable页面切换出现异常:');
      }
    },
    // init(params) {
    //   this.loading = true;
    //   // 如果采用微服务的方式需要传微服务和url
    //   this.$api[this.server]
    //     [this.url](params)
    //     .then((res) => {
    //       this.tableData = res.data || [];
    //       // 如果有分页
    //       if (this.paging) {
    //         this.tableCount = res.count || 0;
    //         this.params.page = res.curr || 0;
    //       }
    //     })
    //     .finally(() => {
    //       // 关闭loading
    //       this.loading = false;
    //     });
    // },
    // 重新请求 //如果需要重新请求使用$refs 调用这个方法
    // reload() {
    //   // 如果有分页
    //   if (this.paging) {
    //     this.params.page = 1;
    //   }
    //   // api动态加载完 开始重新请求数据
    //   this.$nextTick(() => {
    //     this.init(this.params);
    //   });
    // },
    // 以下是对el-table原来的方法再次封装emit出去
    // 多选
    selectionChange(val) {
      this.$emit("selection-change", val);
    },
    // 单选
    currentChange(currentRow, oldCurrentRow) {
      this.$emit("current-change", currentRow, oldCurrentRow);
    },
    rowClick(row, event, column) {
      this.$emit("row-click", row, event, column);
    },
    // 排序
    sortChange(column, prop, order) {
      this.$emit("sort-change", column, prop, order);
    },
    // 表格翻页
    // pageChange(page) {
    //   this.params.page = page;
    //   this.init(this.params);
    // },
    // limitChange(limit) {
    //   this.params.limit = limit;
    //   this.init(this.params);
    // },
    setHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        // return 'background-color: rgb(245 245 246);'
      }
      if (rowIndex === 1 && this.headerRowable) {
          return {
            display: "none",
          };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.table-header {
  height: 0.35rem;
}
/deep/ .el-table {
  width: 100%;
}

/deep/ .el-table__header-wrapper {
  position: sticky;
  top: 0;
  z-index: 1;
}
// /deep/ .el-table__body-wrapper {
  //   // height: 89% !important;
  //   height: calc(100% - .47rem);
  //   overflow-y: auto !important;
  //   // z-index: 100;
  // }
  // 点击的时候添加的class样式
  // .el-table__body tr.current-row > td {
    //   background-color: #1f2d3da1 !important;
    //   color: #fff;
    // }
    //解决固定表头后，表头复选框和行复选框不对齐问题
    /deep/ .el-table-column--selection .cell{
      padding-left:10px;
      padding-right: 10px;
    }
    //修改表头文字样式
    /deep/ .el-table thead th.is-leaf{
      border-top: 0.01rem solid #CBDCED;
      border-bottom: 0.01rem solid #CBDCED;
      background: #F0F4F8;
      padding: 0.1rem 0;
      .cell{
        font-weight: 800;
        font-size: 0.16rem
      }
    }
.indexBox {
    width: 34px;
    height: 100%;
    margin-left: -0.1rem;
    span {
      display: flex;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      text-align: center;
      position: absolute;
      align-items: center;
      justify-content: center;
    }
    img {
      float: left;
      width: 33px;
      height: 14px;
      border: none;
      margin-bottom: 1px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/EXTable/index.vue